import { Badge, Button, Flex, Input, Text } from "@chakra-ui/react";
import { useMutation, useQueryClient } from "react-query";
import { apiBlog } from "../../../../services/api";


async function deactivateLink(id, userId) {
  try {
    const response = await apiBlog.patch(`/deactivateLink`, { id }, {
      headers: {
        Authorization: `Bearer ${userId}`
      }
    })

    return response.data
  } catch (err) {
    return err
  }
}

async function activateLink(id, userId) {
  try {
    const response = await apiBlog.patch(`/activateLink`, { id }, {
      headers: {
        Authorization: `Bearer ${userId}`
      }
    })

    return response.data
  } catch (err) {
    return err
  }
}

export function Card({ link, userId }) {

  const queryClient = useQueryClient()


  const { mutateAsync: mutateDeactivateLink, isLoading: deactivateLinkLoading } = useMutation({

    mutationFn: (id) => deactivateLink(id, userId),
    //setQueryData no isActived\
    onSuccess: (data) => {
      queryClient.setQueryData('getLinks', (oldData) => {
        return oldData.map(link => {
          if (link.id === data.id) {
            return {
              ...link,
              isActived: false
            }
          }
          return link
        })
      })
    }
    
  })

  const { mutateAsync: mutateActivateLink, isLoading: activateLinkLoading } = useMutation({
    mutationFn: (id) => activateLink(id, userId),
    onSuccess: (data) => {
      queryClient.setQueryData('getLinks', (oldData) => {
        return oldData.map(link => {
          if (link.id === data.id) {
            return {
              ...link,
              isActived: true
            }
          }
          return link
        })
      })
    }
  })

  async function handleActivateLink(id) {
    await mutateActivateLink(id)
  }


  async function handleDeactivateLink(id) {
    await mutateDeactivateLink(id)
  }


  return (
    <Flex flexDir="column" key={link.id} align="start" bg="gray.100">
      <Text bg="blue.300" color="white" w="full" textAlign="center">{link.name}</Text>
      <Flex gap={2} w="full" py={2} px={2}>
        <Text p={2}>Link:</Text>
        <Input value={link.url} />
      </Flex>
      <Flex flexDir="column" gap={2} w="full" p={2}>
        <Text>
          Esse link está {" "}
          <Badge colorScheme={link.isActived ? 'green' : 'red'}>{link.isActived ? 'Ativo' : 'Inativo'}</Badge>
        </Text>

        {link.isActived ? (
          <Button 
            colorScheme="red"
            onClick={() => handleDeactivateLink(link.id)}
            isLoading={deactivateLinkLoading}
          >
            Desativar
          </Button>
        ) : (
          <Button 
            colorScheme="green"
            onClick={() => handleActivateLink(link.id)}
            isLoading={activateLinkLoading}
          >
            Ativar
          </Button>
        )
        }
      </Flex>
    </Flex>
  )
}